// src/utils/holidayBackgrounds.ts

export interface HolidayBackground {
  name: string;
  startDate: string; // in MM-DD format
  endDate: string;   // in MM-DD format
  backgroundGif: string;
  snowfall: boolean;
}

export const holidayBackgrounds: HolidayBackground[] = [
  {
    name: 'Holiday Season',
    startDate: '12-01',
    endDate: '12-19',
    backgroundGif: './assets/images/holiday-season-bg.gif', // ✅ Use your actual image/GIF file here
    snowfall: true,
  },
  {
    name: 'Christmas',
    startDate: '12-20',
    endDate: '12-26',
    backgroundGif: './assets/images/christmas-bg.gif',
    snowfall: true,
  },
  {
    name: 'New Year',
    startDate: '12-31',
    endDate: '01-02',
    backgroundGif: './assets/images/newyear-bg.gif',
    snowfall: false,
  },
  {
    name: 'Independence Day',
    startDate: '07-03',
    endDate: '07-05',
    backgroundGif: './assets/images/usa-flag-bg.gif',
    snowfall: false,
  },
  {
    name: 'Thanksgiving',
    startDate: '11-23',
    endDate: '11-27',
    backgroundGif: './assets/images/thanksgiving-bg.gif',
    snowfall: false,
  },
  {
    name: 'Test Week July',
    startDate: '07-24',
    endDate: '07-31',
    backgroundGif: './assets/images/usa-flag-bg.gif', // ✅ Add your test image in src/assets/images
    snowfall: false,
  },

];
